export default "__VITE_ASSET__98fa3db6__"